// hooks/useUtmParams.js

import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'

// The key we'll use for storing data in the browser's local storage.
const UTM_STORAGE_KEY = 'ev_check_utm_data'

/**
 * Hook to capture and store UTM parameters from the URL.
 * This hook will run on every page change and will save any UTM parameters it finds.
 */
export const useUtmParams = () => {
  const searchParams = useSearchParams()
  const [utmData, setUtmData] = useState(null)

  useEffect(() => {
    // First, we attempt to read any data that might already be stored.
    const storedUtm = localStorage.getItem(UTM_STORAGE_KEY)
    if (storedUtm) {
      try {
        setUtmData(JSON.parse(storedUtm))
      } catch (e) {
        console.error('Error parsing stored UTM data:', e)
      }
    }

    // Next, we look for new parameters in the current URL.
    const paramsFromUrl = {}
    // The list of parameters we are interested in capturing.
    const utmKeys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'gad_source',
      'pid',
      'c',
    ]

    utmKeys.forEach((key) => {
      if (searchParams.has(key)) {
        paramsFromUrl[key] = searchParams.get(key)
      }
    })

    // If we find any parameters in the URL, we save them to localStorage.
    // This overwrites any previous data, ensuring that the data from the last click persists.
    if (Object.keys(paramsFromUrl).length > 0) {
      try {
        localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(paramsFromUrl))
        setUtmData(paramsFromUrl)
      } catch (e) {
        console.error('Error storing UTM data:', e)
      }
    }
  }, [searchParams]) // This runs whenever the URL search parameters change.

  return { utmData }
}
